import { render, staticRenderFns } from "./carousel-slide.vue?vue&type=template&id=6047fb6e"
import script from "./carousel-slide.vue?vue&type=script&lang=ts"
export * from "./carousel-slide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports